export default __webpack_public_path__ + "static/media/thaigo-screenshot-04.0682d323.png";